import React, { useState, useEffect } from 'react';
import { 
  Brain, Loader2, CheckCircle, AlertCircle, Send
} from 'lucide-react';
import { studentPanelAPI } from '../../services/api';

const StudentSuicideTest = () => {
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [completed, setCompleted] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [currentQuestion, setCurrentQuestion] = useState(0);

  useEffect(() => {
    fetchTest();
  }, []);

  const fetchTest = async () => {
    try {
      const response = await studentPanelAPI.getSuicideTest();
      if (response.data.completed) {
        setCompleted(true);
      } else {
        const q = response.data.questions || [];
        setQuestions(q);
        if (q.length === 0) {
          console.log('Savollar topilmadi');
        }
      }
    } catch (error) {
      console.error('Xato:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAnswer = (questionId, answer) => {
    setAnswers(prev => ({
      ...prev,
      [questionId]: answer
    }));
  };

  const handleSubmit = async () => {
    // Barcha savollar javoblanganligini tekshirish
    if (Object.keys(answers).length < questions.length) {
      alert("Iltimos, barcha savollarga javob bering!");
      return;
    }
    
    setSubmitting(true);
    try {
      await studentPanelAPI.submitSuicideTest({ answers });
      setCompleted(true);
    } catch (error) {
      alert('Xatolik yuz berdi');
    } finally {
      setSubmitting(false);
    }
  };

  const getAnsweredCount = () => {
    return Object.keys(answers).length;
  };

  if (loading) {
    return (
      <div className="loading-container">
        <Loader2 className="spinner" size={40} />
        <p>Yuklanmoqda...</p>
      </div>
    );
  }

  if (completed) {
    return (
      <div className="page-container">
        <div className="test-completed-card" style={{
          maxWidth: '500px',
          margin: '60px auto',
          textAlign: 'center',
          padding: '48px',
          background: 'white',
          borderRadius: '20px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            background: '#d1fae5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px'
          }}>
            <CheckCircle size={40} color="#10b981" />
          </div>
          <h2 style={{ color: '#1e293b', marginBottom: '12px' }}>Test yakunlandi!</h2>
          <p style={{ color: '#64748b', fontSize: '16px' }}>
            Javoblaringiz muvaffaqiyatli qabul qilindi. Natijalar psixolog tomonidan tahlil qilinadi.
          </p>
        </div>
      </div>
    );
  }

  // Savollar bo'sh bo'lsa
  if (questions.length === 0) {
    return (
      <div className="page-container">
        <div style={{
          maxWidth: '500px',
          margin: '60px auto',
          textAlign: 'center',
          padding: '48px',
          background: 'white',
          borderRadius: '20px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            background: '#fef3c7',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px'
          }}>
            <AlertCircle size={40} color="#f59e0b" />
          </div>
          <h2 style={{ color: '#1e293b', marginBottom: '12px' }}>Test savollar topilmadi</h2>
          <p style={{ color: '#64748b', fontSize: '16px' }}>
            Hozircha test savollari mavjud emas. Iltimos, keyinroq qayta urinib ko'ring.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <header className="page-header">
        <div className="page-title">
          <h1><Brain size={28} /> Psixologik test</h1>
          <p>Quyidagi savollarga to'g'ri javob bering</p>
        </div>
      </header>

      {/* Progress */}
      <div className="card" style={{ marginBottom: '24px' }}>
        <div className="card-body" style={{ padding: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
            <span style={{ color: '#64748b', fontWeight: '500' }}>Javob berildi</span>
            <span style={{ color: '#3b82f6', fontWeight: '600' }}>
              {getAnsweredCount()} / {questions.length}
            </span>
          </div>
          <div style={{
            width: '100%',
            height: '8px',
            background: '#e2e8f0',
            borderRadius: '4px',
            overflow: 'hidden'
          }}>
            <div style={{
              width: `${(getAnsweredCount() / questions.length) * 100}%`,
              height: '100%',
              background: '#3b82f6',
              borderRadius: '4px',
              transition: 'width 0.3s ease'
            }} />
          </div>
        </div>
      </div>

      {/* Ko'rsatmalar */}
      <div className="alert" style={{
        background: '#eff6ff',
        border: '1px solid #bfdbfe',
        borderRadius: '12px',
        padding: '16px 20px',
        marginBottom: '24px',
        display: 'flex',
        alignItems: 'flex-start',
        gap: '12px'
      }}>
        <AlertCircle size={24} color="#3b82f6" style={{ flexShrink: 0, marginTop: '2px' }} />
        <div>
          <strong style={{ color: '#1e40af' }}>Ko'rsatma:</strong>
          <p style={{ margin: '4px 0 0', color: '#3730a3', fontSize: '14px' }}>
            Har bir savolga <strong>"Ha"</strong>, <strong>"Yo'q"</strong> yoki <strong>"Bilmayman"</strong> javoblaridan birini tanlang.
          </p>
        </div>
      </div>

      {/* Savollar */}
      <div className="questions-list">
        {questions.map((q, index) => (
          <div 
            key={q.id} 
            className="question-card"
            style={{
              background: 'white',
              borderRadius: '16px',
              padding: '24px',
              marginBottom: '16px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              border: answers[q.id] ? '2px solid #10b981' : '1px solid #e2e8f0',
              transition: 'all 0.2s'
            }}
          >
            <div style={{ display: 'flex', gap: '16px' }}>
              <div style={{
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                background: answers[q.id] ? '#d1fae5' : '#f1f5f9',
                color: answers[q.id] ? '#10b981' : '#64748b',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '600',
                flexShrink: 0
              }}>
                {index + 1}
              </div>
              <div style={{ flex: 1 }}>
                <p style={{ 
                  margin: '0 0 16px', 
                  color: '#1e293b', 
                  fontSize: '16px',
                  lineHeight: '1.6'
                }}>
                  {q.question_text}
                </p>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                  <button
                    onClick={() => handleAnswer(q.id, 'yes')}
                    style={{
                      padding: '10px 24px',
                      borderRadius: '25px',
                      border: 'none',
                      background: answers[q.id] === 'yes' ? '#10b981' : '#f1f5f9',
                      color: answers[q.id] === 'yes' ? 'white' : '#475569',
                      fontWeight: '500',
                      cursor: 'pointer',
                      transition: 'all 0.2s'
                    }}
                  >
                    Ha
                  </button>
                  <button
                    onClick={() => handleAnswer(q.id, 'no')}
                    style={{
                      padding: '10px 24px',
                      borderRadius: '25px',
                      border: 'none',
                      background: answers[q.id] === 'no' ? '#ef4444' : '#f1f5f9',
                      color: answers[q.id] === 'no' ? 'white' : '#475569',
                      fontWeight: '500',
                      cursor: 'pointer',
                      transition: 'all 0.2s'
                    }}
                  >
                    Yo'q
                  </button>
                  <button
                    onClick={() => handleAnswer(q.id, 'unknown')}
                    style={{
                      padding: '10px 24px',
                      borderRadius: '25px',
                      border: 'none',
                      background: answers[q.id] === 'unknown' ? '#f59e0b' : '#f1f5f9',
                      color: answers[q.id] === 'unknown' ? 'white' : '#475569',
                      fontWeight: '500',
                      cursor: 'pointer',
                      transition: 'all 0.2s'
                    }}
                  >
                    Bilmayman
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Yuborish tugmasi */}
      <div style={{ 
        marginTop: '32px', 
        display: 'flex', 
        justifyContent: 'center',
        paddingBottom: '40px'
      }}>
        <button
          onClick={handleSubmit}
          disabled={submitting || getAnsweredCount() < questions.length}
          className="btn btn-primary"
          style={{
            padding: '16px 48px',
            fontSize: '16px',
            borderRadius: '12px',
            opacity: getAnsweredCount() < questions.length ? 0.5 : 1
          }}
        >
          {submitting ? (
            <><Loader2 className="spinner" size={20} /> Yuborilmoqda...</>
          ) : (
            <><Send size={20} /> Testni yakunlash</>
          )}
        </button>
      </div>
    </div>
  );
};

export default StudentSuicideTest;
